import NavbarContainer from "./containers/NavbarContainer";
import "./styles.scss";

export default NavbarContainer;
